import { REACT_APP_ENV_NAME } from 'lily-env';

export const isProduction = () => REACT_APP_ENV_NAME === 'production';

export const isStageOnLocal = () => REACT_APP_ENV_NAME === 'staging' && window.location.host.includes('localhost');
